import React from 'react';
import classNames from 'classnames';
import style from './PaymentReferenceNumbers.module.css';
export default function PaymentReferenceNumbers(_ref) {
  var transactionRef = _ref.transactionRef,
    payeeRef = _ref.payeeRef;
  if (!transactionRef && !payeeRef) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.cardBody, " js-payment-reference-numbers")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.paymentRefs, 'zb-dark-grey-2')
  }, /*#__PURE__*/React.createElement("div", {
    className: "js-transaction-reference"
  }, transactionRef && /*#__PURE__*/React.createElement(KeyValuePair, {
    field: "Transaction reference",
    value: transactionRef
  })), /*#__PURE__*/React.createElement("div", {
    className: "js-payee-reference"
  }, payeeRef && /*#__PURE__*/React.createElement(KeyValuePair, {
    field: "Payee reference",
    value: payeeRef
  }))));
}
export function VrpReferenceNumbers(_ref2) {
  var payeeRef = _ref2.payeeRef;
  if (!payeeRef) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.cardBody, " js-payment-reference-numbers")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.paymentRefs, 'zb-dark-grey-2')
  }, /*#__PURE__*/React.createElement("div", {
    className: "js-remittance"
  }, /*#__PURE__*/React.createElement(KeyValuePair, {
    field: "Payee reference",
    value: payeeRef
  }))));
}
function KeyValuePair(_ref3) {
  var field = _ref3.field,
    value = _ref3.value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "js-label"
  }, field, ":"), ' ', /*#__PURE__*/React.createElement("span", {
    className: "js-value"
  }, value));
}